import styled from 'styled-components';
import { Typography } from '../Typography';
import Link from '../Link';
import { IconExternal } from '@components/icons';
import Button from '../Button';

export const DataWrap = styled.div`
  font-size: 1.4rem;
`;

export const NftImageWrapper = styled.div`
  font-size: 1.4rem;
  padding-left: 10vw;
  display: flex;
  align-items: flex-start;
  img {
    width: auto;
    aspect-ratio: 1;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding-left: 0;
    padding-top: 2rem;
    img {
      height: 100px;
    }
  }
`;

export const NftWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  white-space: nowrap;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    display: flex;
    flex-direction: column;
  }
`;

export const InfoContainer = styled.div`
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    width: 34rem;
  }
`;

export const StyledSpan = styled(Typography)<{ isValue?: boolean }>`
  display: block;
  font-family: ${({ theme }) => theme.fonts.archivo};
  color: ${({ theme }) => theme.colors.functional.darkGray};
  ${({ isValue }) =>
    isValue &&
    `
    font-weight: 700;
    width: 40%;
    text-align: left;
  `}
`;

export const StyledRow = styled.div<{ withMarginBottom?: boolean; nftContainer?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  ${({ withMarginBottom }) => withMarginBottom && `margin-bottom: 24px;`}
  ${StyledSpan} {
    &:first-child {
      width: 140px;
    }
  }

  img {
    object-fit: contain;
  }

  ${({ nftContainer }) => nftContainer && `padding-right: 2rem;`}
`;

export const StyledLink = styled(Link)`
  fill: ${({ theme }) => theme.colors.primary.main};
`;

export const ExternalStyledLink = styled(Link)`
  fill: ${({ theme }) => theme.colors.primary.main};
  padding: 2px 3rem 2px 0;
  border-bottom: 0;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: calc(100% - 3rem);
    height: 2px;
    background: ${({ theme }) => theme.colors.primary.main};
  }
  svg {
    position: absolute;
    right: 0;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: fit-content;
  padding: 1rem 0;
  ${StyledLink} {
    margin-right: 2.4rem;
  }
`;

export const StyledIconExternal = styled(IconExternal)`
  width: 24px;
  margin-left: 10px;
`;

export const ConfirmationWrapper = styled.div`
  font-size: 1.4rem;
  h4 {
    padding: 40px 0 16px;
  }
  em {
    font-style: normal;
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: 700;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    font-size: 1.2rem;
  }
`;

export const Text = styled.div`
  width: 50%;
  a {
    text-decoration: underline;
  }
`;

export const StyledButton = styled(Button)`
  width: 228px;
  margin-right: 2.4rem;
`;
